import { gql } from "@apollo/client";

export const IS_AUTH_QUERY = gql`
  {
    isAuthenticated {
      status
    }
    getUserByToken {
      id
      firstName
      lastName
      email
      language
      timezone
      userCategory {
        id
        slug
      }
      role {
        id
        order
      }
      isSuperuser
      isNewraiUser
      groups {
        id
        order
      }
      accountingFirms
      companies
      permissions
    }
  }
`;
